import React from 'react';

import { UnpaidFineSummaryProps } from './types';

import { UnpaidTableRow } from '..';

export const UnpaidFineSummary: React.FC<UnpaidFineSummaryProps> = ({
  onCheck,
  showCheckBox = true,
  className,
  checked,
  fine,
  hasImage,
  excludeImage = false,
}) => {
  return (
    <UnpaidTableRow
      key={fine.id}
      onCheck={onCheck}
      checked={checked}
      showCheckBoxes={showCheckBox}
      className={`my-2 ${className}`}
      aartoFee={fine.aartoFee}
      amountPaid={fine.amountPaid}
      area={fine.area}
      discount={fine.discount}
      enforcementOrder={fine.enforcementOrder}
      infringementPenaltyLevyFee={fine.infringementPenaltyLevyFee}
      fineAmount={fine.fineAmount}
      offenceDate={fine.date.toLocaleString()}
      reason={fine.reason}
      regNo={fine.vehicleRegistration}
      serviceFee={fine.serviceFee}
      ticketNumber={fine.noticeNumber}
      total={fine.total}
      totalOutstanding={fine.total}
      demeritPoints={fine.demeritPoints}
      hasImage={hasImage}
      evidenceTokens={fine.evidence}
      isNag={fine.isNag}
      isPayable={fine.isPayable}
      provider={fine.provider}
      excludeImage={excludeImage}
    />
  );
};
